import type { Static } from 'runtypes';
import { Literal, Number, Record, String, Boolean } from 'runtypes';
import { CoreEventRuntype } from './core';
import { ClickstreamEventEnum } from 'bc-model';

const SessionTerminatedEventRuntype = CoreEventRuntype.And(
  Record({
    duration: Number,
    event: Literal(ClickstreamEventEnum.SESSION_TERMINATED),
    isDurationReliable: Boolean,
    sessionId: String,
    version: Literal(3),
  })
);

type SessionTerminatedEvent = Omit<
  Static<typeof SessionTerminatedEventRuntype>,
  'isDurationReliable'
> & {
  isDurationReliable?: boolean;
};

export { SessionTerminatedEventRuntype, type SessionTerminatedEvent };
